export default __webpack_public_path__ + "8c0023b7312e106995a3e1d2a8af8ed5.png";